<script setup>
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

import * as dataGrid from '@/composables/data-grid'
import { useDefaultDialogTitle } from '@/composables/data-grid'

import { DxDataGrid } from 'devextreme-vue'

import { useRegistryStore } from '@/stores/registry.store'

const props = defineProps({
  readOnly: { type: Boolean }
})

const gridId = 'external-data-processor-grid'
const gridRef = ref(null)
const i18n = getI18n()

const registryStore = useRegistryStore()

const columns = [
  { dataField: 'role', caption: i18n.t('common.companyData.privacy.roleDataProcessor'), validationRules: [{ type: 'required' }] },
  { dataField: 'company_name', caption: i18n.t('common.companyName'), validationRules: [{ type: 'required' }] },
  { dataField: 'branch_address', caption: i18n.t('common.companyData.privacy.branchRegistered') },
  { dataField: 'contact_details', caption: i18n.t('common.contactDetails') },
  { dataField: 'email', caption: i18n.t('common.email') },
  { dataField: 'email_certified', caption: i18n.t('common.emailCertified') },
  { dataField: 'tax_code', caption: i18n.t('common.taxCode') },
  { dataField: 'vat_number', caption: i18n.t('common.vatNumber') }
]

const {defaultDialogTitle} = useDefaultDialogTitle()
const editing = dataGrid.useDefaultEditing(i => defaultDialogTitle(i, i18n.t('common.externalDataProcessor')), {
  itemType: 'group',
  colCount: 1,
  items: [
    {
      itemType: 'group',
      colCount: 2,
      items: [
        { dataField: 'role'},
        { dataField: 'company_name'},
        { dataField: 'branch_address'},
        { dataField: 'contact_details'},
        { dataField: 'email'},
        { dataField: 'email_certified'},
        { dataField: 'tax_code'},
        { dataField: 'vat_number'},
      ]
    }
  ]
}, {
  allowAdding: true,
  allowUpdating: true,
  allowDeleting: true,
})

const dataSource = dataGrid.useODataSource(registryStore.api.getAbsoluteUrl() + registryStore.api.externalPrivacyDataProcessorsUrl)
const gridOptions = dataGrid.useDefaultGridOptions({
  id: gridId,
  dataSource: dataSource,
  columns: columns,
  editing: editing,
  columnChooser: { enabled: false },
  filterRow: { visible: !props.readOnly },
  height: '100%',
})
</script>
<template>
  <dx-data-grid
    ref="gridRef"
    v-bind="gridOptions"
  />
</template>
